import main from './main';

const all = {
	...main
};

export default all;
